import React from "react";
import styled from "styled-components"
import Button from "./Button"

const Card = styled.div`
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  padding: 1.5rem 1.5rem;
  h5 {
    border-left: 5px solid transparent;
    text-align: center;
  }
`

const ContactContainer = styled.div`
padding: 10vh 0 0 0;
@media only screen and (min-width: 1200px) {
padding: 10vh 0 0 10vw;

}
`

const TextContainer = styled.div`
padding: 10vh 0 10vh 0;
  h5 {
    color: #0238AF;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    margin: 0 0 .5rem 0;
    border-left: 5px solid #CE0101;
    padding: 0 0 0 .5rem;
  }
  h5:not(:first-child) {
  margin: 5vh 0 .5rem 0;
  }
  p {
    font-family: "Open Sans", sans-serif; 
  }
  p:not(:first-child) {
  margin: 1rem 0 0 0;
  }

`

const PageLayout = (props) => {

  return (
    <TextContainer {...props}  className="container is-fluid">
      <div className="columns">
        <div className="column is-half">
          {props.children}
        </div>
        <div className="column is-half">
          <ContactContainer>
            <Card>

              <h5>Schedule a Service Call</h5>
              <form>
                <div className="field">
                  <label className="label">Your Name</label>
                  <div className="control">
                    <input className="input" type="text" placeholder="Your Name*" required/>
                  </div>
                </div>
                <div className="field">
                  <label className="label">Your Email</label>
                  <div className="control">
                    <input className="input" type="text" placeholder="Your Email" required/>
                  </div>
                </div>
                <div className="field">
                  <label className="label">Your Phone Number</label>
                  <div className="control">
                    <input className="input" type="text" placeholder="Your Phone Number*" required/>
                  </div>
                </div>
                <div className="field">
                  <label className="label">Your Message</label>
                  <div className="control">
                    <textarea className="textarea" placeholder="Your Message*" required/>
                  </div>
                </div>
                <Button m="3rem 0 0 0" p=".5rem 1.5rem .5rem 1.5rem">Submit</Button>
              </form>
            </Card>
          </ContactContainer>
        </div>
      </div>

    </TextContainer>
  )
}

export default PageLayout;